import React from "react"
import { Link } from "gatsby"

import Layout from "../Layout"

import TopicsLong from "../TopicsLong";

import Contact from "../Contact";

import SEO from "../seo"
const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <TopicsLong lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage
